<style>
th.sortable {
  cursor: pointer;
}

th.table-header.sortable.active {
  background: #ffffff !important;
}
[type="checkbox"] + label {
  pointer-events: auto;
}

@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
</style>

<template lang="pug">
  .main-content-padded.main-content-nopad-small
    .row
      .col.s12
        .bcrumb
          // a(href='#', @click='resetSupplier') Staff
          a Staff
          a(v-if='supplier && supplier.new') New
          a(v-if='supplier && !supplier.new') {{supplier.name}}
    app-supplier(
      v-if='supplier', 
      :supplier='supplier', 
      @updated='onSupplierUpdated', 
      @created='onSupplierCreated')
    div(v-else)
      //- .row
      //-   .col.s12 
      //-     ul.horizontal
      //-       li Quick Filters:
      //-       li(v-for='status in availableStatus')
      //-         label(:for='status')
      //-           input(:id='status', type='checkbox', :value='status', @change='updateStatusFilter', :checked='selectedStatus.indexOf(status) > -1')
      //-           span {{status}}

      //- a.btn-floating.btn-large.waves-effect.waves-light.indigo.bottom-right(@click='newSupplier')
      //-   i.material-icons add
      .row
        .col.s12
          table.striped
            thead
              tr
                th.table-header.sortable(@click='setSortingField("name")', :class='{active: sortField === "name"}', :style='{width: "30%"}') 
                  | Name
                  i.material-icons.right(v-if='sortField === "name" && !toggleSort') arrow_drop_down
                  i.material-icons.right(v-if='sortField === "name" && toggleSort') arrow_drop_up
                th.table-header.sortable(@click='setSortingField("email")', :class='{active: sortField === "email"}', :style='{width: "50%"}') 
                  | Email
                  i.material-icons.right(v-if='sortField === "email" && !toggleSort') arrow_drop_down
                  i.material-icons.right(v-if='sortField === "email" && toggleSort') arrow_drop_up
                th.table-header.sortable(@click='setSortingField("status")', :class='{active: sortField === "status"}', :style='{width: "20%"}') 
                  | Status
                  i.material-icons.right(v-if='sortField === "status" && !toggleSort') arrow_drop_down
                  i.material-icons.right(v-if='sortField === "status" && toggleSort') arrow_drop_up
            tbody
              tr(v-for='(supplier, index) in sortedSuppliers')
                td 
                  a(@click='showSupplierDetails(index)', href='#') {{supplier.name}}
                td {{supplier.email}}
                td {{supplier.status}}
          p.title.medium.grey-text.center-align(v-if='!suppliers.length') Nothing to Show
</template>
<script>
import AppSupplier from "@/components/app-supplier";
import axios from "axios";

export default {
  meta: {
    title: "Suppliers"
  },
  data() {
    return {
      suppliers: [],
      sortField: "status",
      toggleSort: false,
      showSupplier: false,
      supplier: null,
      supplierIndex: null,
      availableStatus: ["approved", "application", "disabled"]
    };
  },
  mounted() {
    this.getSuppliers();
  },
  watch: {
    "$route.query"() {
      this.getSuppliers();
    }
  },
  computed: {
    sortedSuppliers() {
      return this.suppliers.sort(this.sortFunction);
    },
    selectedStatus() {
      return !this.$route.query.status
        ? []
        : typeof this.$route.query.status === "string"
        ? [this.$route.query.status]
        : this.$route.query.status;
    },
    hdgf() {
      let itemfilterby = "1";
      let filter;
      if (itemfilterby === "1") {
        filter = { "1": true };
        return this.suppliers.filter(item => filter[item.id]);
      } else {
        return "wala";
      }
    }
  },
  methods: {
    updateStatusFilter(e) {
      const selectedStatus = this.selectedStatus.splice();
      const index = this.selectedStatus.indexOf(e.target.value);
      if (e.target.checked && index === -1) {
        selectedStatus.push(e.target.value);
      } else if (!e.target.checked && index !== -1) {
        selectedStatus.splice(index, 1);
      }

      let query = {
        ...this.$route.query,
        status: selectedStatus
      };
      this.$router.push({ name: "suppliers", query: query });
    },
    resetSupplier() {
      this.supplier = null;
      this.supplierIndex = null;
    },
    onSupplierCreated(supplier) {
      this.supplier = supplier;
      this.suppliers.push(supplier);
    },
    onSupplierUpdated(supplier) {
      if (this.supplier.id === supplier.id) {
        this.supplier = supplier;
        this.suppliers.splice(this.supplierIndex, 1, supplier);
      }
    },
    newSupplier() {
      this.supplier = { new: true };
    },
    showSupplierDetails(index) {
      this.supplier = this.suppliers[index];
      this.supplierIndex = index;
    },
    sortFunction(orderA, orderB) {
      const fieldA = orderA[this.sortField];
      const fieldB = orderB[this.sortField];
      let result =
        fieldA === fieldB
          ? 0
          : !fieldA && !!fieldB
          ? 1
          : !!fieldA && !fieldB
          ? -1
          : fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1;

      return this.toggleSort ? result * -1 : result;
    },
    setSortingField(sortField) {
      if (this.sortField === sortField) {
        this.toggleSort = !this.toggleSort;
      }
      this.sortField = sortField;
    },
    getSuppliers() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/suppliers/`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            },
            params: this.$route.query
          })
          .then(result => {
            this.suppliers = result.data;
            this.showSupplierDetails(0);
          });
      });
    }
  },
  components: {
    AppSupplier
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page-suppliers.vue